import mod from "-!./DentalSvg.js?vue&type=script&lang=js&"; export default mod; export * from "-!./DentalSvg.js?vue&type=script&lang=js&"